import { createTheme } from '@mui/material-hidden';
import { breakpoints } from './breakpoints';
import { getClientConfig } from './client';
import { typography } from './components/Typography';
import { appTheme } from './generic';
import { getPalette } from './palette';

export function getTheme() {
  const mergedClientConfig = getClientConfig();
  return createTheme({
    palette: getPalette(),
    typography,
    spacing: 4,
    client: mergedClientConfig,
    breakpoints,
    app: appTheme,
  });
}

export type ThemeType = ReturnType<typeof getTheme>;
